import React, { useCallback, useState } from 'react';
import styles from './TagsFilter.module.scss';
import searchFiltersStyles from '../SearchFilters.module.scss';
import { scrollToTop, clearTag } from '../../helpers/Utils';

interface TagsFilterProps {
    filterId: string;
    indexPropertyName: string;
    title: string;
    tags: string[];
    selectedTags: string[]; // New prop to track selected tags
    onTagSelect: (filterId: string, tag: string) => void;
}

const TagsFilter: React.FC<TagsFilterProps> = ({ filterId, indexPropertyName, title, tags, selectedTags, onTagSelect }) => {
    const [processingTag, setProcessingTag] = useState<string | null>(null);

    const handleTagClick = useCallback(
        (e: React.MouseEvent<HTMLAnchorElement>, t: string) => {
            const tag = clearTag(t);
            e.preventDefault(); // Prevent default link behavior
            if (processingTag === tag) return; // Prevent duplicate processing for the same tag
            setProcessingTag(tag);
            onTagSelect(indexPropertyName, tag);
            scrollToTop();
            setTimeout(() => setProcessingTag(null), 300); // Reset after a short delay
        },
        [filterId, indexPropertyName, onTagSelect, processingTag]
    );

    return (
        <React.Fragment>
            {/* Tags Filter */}
            <div className={`${styles["tags-filter"]} ${searchFiltersStyles["filter-item"]}`}>
                <h3 className={searchFiltersStyles["filter-title"]}>{title}</h3>
                <ul>
                    {tags?.map((t, index) => {
                        const tag = clearTag(t);
                        const isSelected = selectedTags.includes(tag); // Check if the tag is selected
                        const isDisabled = processingTag === tag; // Check if the tag is being processed
                        return (
                            <li key={index}>
                                <a
                                    href="#"
                                    className={`${isSelected ? styles["selected"] : ""} ${isDisabled ? styles["disabled"] : ""}`}
                                    onClick={(e) => handleTagClick(e, tag)} // Use debounced handler
                                    aria-disabled={isDisabled} // Accessibility support
                                >
                                    {tag}
                                </a>
                            </li>
                        );
                    })}
                </ul>
            </div>
            {/* /Tags Filter */}
        </React.Fragment>
    );
};

export default TagsFilter;